import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  GenericIconName,
  Icon,
  RADIUS,
  SPACING,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export interface MissionBadgeProps {
  className?: string;
  small?: boolean;
  showCoinsLabel?: boolean;
  reward: number;
}

export const MissionBadge: React.FC<MissionBadgeProps> = ({
  className,
  small,
  showCoinsLabel,
  reward,
}) => {
  const {t} = useTranslation();

  return (
    <Wrapper
      className={className}
      $small={small}
      data-testid="coinsMissionBadge"
    >
      <Icon asset={GenericIconName.Coins} size={small ? 'XSS' : 'XS'} />
      <Text weight="mediumHeavy">
        +{reward} {showCoinsLabel && t('Coins')}
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div<{$small?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: fit-content;
  background-color: ${COLORS['Fill.Grey.Primary']};
  border-radius: ${RADIUS.Round};
  height: ${({$small}) => ($small ? '20px' : '28px')};
  padding-inline: ${({$small}) =>
    $small
      ? `${SPACING['X.Sm']} ${SPACING['X.Md']}`
      : `${SPACING['X.Md']} ${SPACING['X.Md']}`};

  > span {
    display: block;
    font-size: ${({$small}) => ($small ? FONT_SIZES.px10 : FONT_SIZES.px14)};
    padding-right: ${({$small}) => ($small ? '0' : SPACING['X.Sm'])};
  }
`;
